import React from 'react';

function FeedbackEmailIcon() {
  return (
    <svg width={64} height={64} fill="none">
      <title>Ilustração de verificado dentro de um círculo</title>
      <path
        d="M62.5 32c0 16.845-13.655 30.5-30.5 30.5S1.5 48.845 1.5 32 15.155 1.5 32 1.5 62.5 15.155 62.5 32z"
        stroke="#8A05BE"
        strokeWidth="3"
      />
      <path
        d="M44.292 25.94l-1.996-1.998-14.531 14.532-6.061-6.061-1.997 1.997 8.058 8.057 16.527-16.528z"
        fill="#8A05BE"
      />
    </svg>
  );
}

export default FeedbackEmailIcon;
